var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageNoti = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F56B57",
  d: "M60 20.25a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3863F0",
  d: "M57.12 24.45c-4.71-1.02-8.55-4.86-9.57-9.57-.39-1.83-.42-3.6-.09-5.28.39-1.86-.99-3.6-2.91-3.6H21C12.72 6 6 12.72 6 21v20.85c0 8.28 6.72 15 15 15h4.5c.84 0 1.92.54 2.4 1.2l4.5 5.97c1.98 2.64 5.22 2.64 7.2 0l4.5-5.97c.57-.75 1.44-1.2 2.4-1.2h4.53c8.28 0 14.97-6.69 14.97-14.97V27.45c0-1.89-1.74-3.27-3.6-2.91-1.68.3-3.45.3-5.28-.09M24 36c-1.68 0-3-1.35-3-3s1.32-3 3-3c1.65 0 3 1.35 3 3s-1.32 3-3 3m12 0c-1.68 0-3-1.35-3-3s1.32-3 3-3c1.65 0 3 1.35 3 3s-1.32 3-3 3m12 0c-1.68 0-3-1.35-3-3s1.32-3 3-3c1.65 0 3 1.35 3 3s-1.32 3-3 3"
})));
export default SvgMessageNoti;